import React from 'react';
import GoConfigSidebar from './GoConfigSidebar';
import GoUsuariosConfig from './components/GoUsuariosConfig';
import GoDispositivosConfig from './components/GoDispositivosConfig';
import GoCustomizacaoConfig from './components/GoCustomizacaoConfig';
import GoProcessosConfig from './components/GoProcessosConfig';
import GoMedicoesConfig from './components/GoMedicoesConfig';
import { useConfigSectionParam } from '../config-hub';

const GO_SUBMENUS = ['usuarios', 'dispositivos', 'customizacao', 'processos', 'medicoes'];

export default function GoConfig() {
  const [activeSubmenu, setActiveSubmenu] = useConfigSectionParam('usuarios', GO_SUBMENUS);

  return (
    <div className="process-config-root">
      <GoConfigSidebar activeSubmenu={activeSubmenu} onSelectSubmenu={setActiveSubmenu} />
      <div className="process-content-area process-content-area-config-status-2">
        {activeSubmenu === 'usuarios' && <GoUsuariosConfig />}
        {activeSubmenu === 'dispositivos' && <GoDispositivosConfig />}
        {activeSubmenu === 'customizacao' && <GoCustomizacaoConfig />}
        {activeSubmenu === 'processos' && <GoProcessosConfig />}
        {activeSubmenu === 'medicoes' && <GoMedicoesConfig />}
      </div>
    </div>
  );
}
